import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { DateFormatService } from '../../services/date-format.service';
/**
 * Converts Date to NgbDateStruct
 */
export const setDateStructure = (date: Date): NgbDateStruct => {
  const fecha = moment(date);
  return {
      year: fecha.get('year'),
      month: fecha.get('month') + 1,
      day: fecha.get('date'),
  };
};

/**
 * Converts Momment to NgbDateStruct
 */
export const setDateStructureM = (date: moment.Moment): NgbDateStruct => ({
  year: date.get('year'),
  month: date.get('month') + 1,
  day: date.get('date'),
});

/**
 * Converts NgbDateStruct to Date
 */
export const setDate = (date: NgbDateStruct) => new Date(date.year, date.month - 1, date.day);

/**
 * Converts NgbDateStruct to Moment
 */
export const setDateM = (date: NgbDateStruct) => {
  if (!date) { return ''; }
  const mdt = moment([date.year, date.month - 1, date.day]);
  if (!mdt.isValid()) { return ''; }
  return mdt.format(new DateFormatService().DT_FORMAT);
};

export const convertDate = (inputFormat) => {
  const pad = (s: number) => (s < 10) ? '0' + s : s;
  const d = new Date(inputFormat);
  return (!isNaN(d.getDate())) ? [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/') : inputFormat;
};
